import classNames from 'classnames';
import * as Accents from '@/assets/graphics/accents/accents';
import Typography from '@/components/atoms/typography/typography';
import styles from './accent.module.scss';

export interface AccentProps {
  /** The class name to apply */
  className?: string;
  /** The text to show in the accent */
  text?: string;
  /** The variant of the accent */
  variant?: keyof typeof Accents;
}

const Accent = ({ className, text, variant = 'Variant1' }: AccentProps) => {
  const AccentComponent = Accents[variant];

  if (!AccentComponent) return null;

  return (
    <div className={classNames(styles.component, className)}>
      <AccentComponent className={styles.accent} />

      {text && (
        <div className={styles.textWrapper}>
          <Typography className={styles.text} tagStyle="displayLarge">
            {text}
          </Typography>
        </div>
      )}
    </div>
  );
};

Accent.displayName = 'Accent';

export default Accent;
